/* BebeLux Black Friday: Kopie von assets/sf-newsletter-hub.js (md5 ded766a0, 27.10.2026) fuer layout/lp-bf.liquid.
 * Unterschiede: handlers.validate() kann vor dem Senden einen Fehlertext liefern (Pflichtfelder). Die Bindung darf optionale Zusatzfelder freigeben ("fields"), die mount() ueber
 * handlers.extras() liefert. Kontaktfelder bleiben an die Bindung gebunden; validierte Attribution und ein
 * Widerspruch werden unabhaengig davon uebertragen. Global: window.BbBfHub, Ereignis sf:bf-hub-ready.
 * BebeLux newsletter transport. Configuration is generated from binding.json.
 * A 202 acknowledgment is not proof of consent, list membership or mail delivery.
 * Sensitive request state exists only in the open page's memory. */
(function (root) {
  'use strict';
  if (root.BbBfHub) return;
  var ATTRIBUTION_FIELDS = ["sc","utm_content","fbclid","fbc","fbp","gclid","gbraid","wbraid","ttclid"];
  var readAttribution = (function(params){var rules={"sc":"^[0-9A-Za-z]{12}$","utm_content":"^[A-Za-z0-9_.:-]{1,128}$","fbclid":"^[A-Za-z0-9_.-]{1,512}$","fbc":"^fb\\.[0-9]{1,2}\\.[0-9]{10,16}\\.[A-Za-z0-9_.-]{1,512}$","fbp":"^fb\\.[0-9]{1,2}\\.[0-9]{10,16}\\.[0-9]{1,30}$","gclid":"^[A-Za-z0-9_-]{1,512}$","gbraid":"^[A-Za-z0-9_-]{1,512}$","wbraid":"^[A-Za-z0-9_-]{1,512}$","ttclid":"^[A-Za-z0-9_.-]{1,512}$"},values={};Object.keys(rules).forEach(function(name){var all=params.getAll(name);if(all.length===1&&!/[\r\n]/.test(all[0])&&new RegExp(rules[name]).test(all[0]))values[name]=all[0];});if(values.fbclid&&values.fbc&&values.fbc.replace(/^fb\.[0-9]{1,2}\.[0-9]{10,16}\./,'')!==values.fbclid)delete values.fbc;return values;});
  var EXTRA_FIELDS = ["first_name","last_name","phone","utm_source","utm_campaign","sc","utm_content","fbclid","fbc","fbp","gclid","gbraid","wbraid","ttclid","event_id","ads_optout"];
  var MESSAGES = {
    de: {
      unavailable: 'Die Newsletter-Anmeldung ist zurzeit nicht verfügbar. Bitte versuche es später erneut.',
      preview: 'Vorschau: Die Anmeldung ist hier deaktiviert.',
      invalid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      retry_locked: 'Bitte wiederhole die Anfrage mit derselben E-Mail-Adresse. Für eine andere Adresse lade diese Seite neu.',
      binding_changed: 'Die Anmeldung wurde inzwischen geändert. Bitte lade diese Seite neu.',
      challenge_expired: 'Das Zeitfenster für diese Anmeldung ist abgelaufen. Die Anfrage wurde angehalten.',
      retry_expired: 'Diese Anfrage ist zu alt, um sie sicher zu wiederholen. Bitte prüfe dein Postfach oder wende dich an den BebeLux-Support.',
      clock_changed: 'Die Zeitprüfung ist nicht mehr zuverlässig. Die Anfrage wurde angehalten. Bitte prüfe dein Postfach oder wende dich an den BebeLux-Support.',
      network: 'Die Anfrage konnte nicht sicher bestätigt werden. Bitte versuche es erneut; deine bisherige Anfrage wird wiederverwendet.',
      protocol: 'Die Anmeldung konnte nicht sicher bestätigt werden. Bitte versuche es später erneut.',
      accepted: 'Falls deine Adresse noch bestätigt werden muss, erhältst du eine E-Mail mit dem Bestätigungslink. Dein persönlicher Willkommensbonus folgt nach der Bestätigung.'
    },
    en: {
      unavailable: 'Newsletter signup is currently unavailable. Please try again later.',
      preview: 'Preview: Signup is disabled here.',
      invalid_email: 'Please enter a valid email address.',
      retry_locked: 'Please retry with the same email address. Reload this page to use a different address.',
      binding_changed: 'Signup settings have changed. Please reload this page.',
      challenge_expired: 'The time window for this signup has expired. The request has been stopped.',
      retry_expired: 'This request is too old to retry safely. Please check your inbox or contact BebeLux support.',
      clock_changed: 'The time check is no longer reliable. The request has been stopped. Please check your inbox or contact BebeLux support.',
      network: 'Your request could not be confirmed. Please try again; your original request will be reused.',
      protocol: 'Signup could not be confirmed. Please try again later.',
      accepted: 'If your address still needs confirmation, you will receive an email with a confirmation link. Your personal welcome bonus follows confirmation.'
    }
  };
  function fault(code) { var error = new Error(code); error.code = code; return error; }
  function localeOf(value) { return /^en(?:-|$)/i.test(value || '') ? 'en' : 'de'; }
  function message(code, locale) { return MESSAGES[localeOf(locale)][code] || MESSAGES[localeOf(locale)].protocol; }
  function validateBinding(raw) {
    if (!raw || typeof raw !== 'object') throw fault('unavailable');
    var origin;
    try { origin = new URL(raw.origin); } catch (_) { throw fault('unavailable'); }
    if (origin.protocol !== 'https:' || origin.origin !== raw.origin || origin.username || origin.password ||
        !/^(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(origin.hostname)) throw fault('unavailable');
    if (typeof raw.formId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(raw.formId)) throw fault('unavailable');
    if (typeof raw.consentTextVersion !== 'string' || !/^[A-Za-z0-9._:-]{1,128}$/.test(raw.consentTextVersion)) throw fault('unavailable');
    if (!Number.isInteger(raw.nonceMaxAgeSeconds) || raw.nonceMaxAgeSeconds < 60 || raw.nonceMaxAgeSeconds > 604800) throw fault('unavailable');
    if (typeof raw.localeField !== 'boolean' || typeof raw.honeypotField !== 'string' ||
        (raw.honeypotField && (!/^[A-Za-z_][A-Za-z0-9_]{0,63}$/.test(raw.honeypotField) ||
        /^(?:email|nonce|consentTextVersion|locale|brand|list)$/i.test(raw.honeypotField)))) throw fault('unavailable');
    var fields = raw.fields === undefined ? [] : raw.fields;
    if (!Array.isArray(fields) || fields.some(function (f) { return EXTRA_FIELDS.indexOf(f) < 0; })) throw fault('unavailable');
    var endpoint = origin.origin + '/m/forms/bebelux/' + raw.formId;
    if (raw.hostedFormUrl !== '' && raw.hostedFormUrl !== endpoint) throw fault('unavailable');
    return Object.freeze({ origin: origin.origin, formId: raw.formId, consentTextVersion: raw.consentTextVersion,
      hostedFormUrl: raw.hostedFormUrl, localeField: raw.localeField, honeypotField: raw.honeypotField,
      nonceMaxAgeSeconds: raw.nonceMaxAgeSeconds, endpoint: endpoint, fields: fields.slice() });
  }
  function normalizeEmail(value) {
    if (typeof value !== 'string') throw fault('invalid_email');
    var email = value.trim();
    if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw fault('invalid_email');
    return email.slice(0, email.lastIndexOf('@') + 1) + email.slice(email.lastIndexOf('@') + 1).toLowerCase();
  }
  function createSession(readBinding, options) {
    options = options || {};
    var binding = validateBinding(readBinding());
    var fingerprint = JSON.stringify(binding);
    var fetchRequest = options.fetch || root.fetch.bind(root);
    var now = options.now || function () { return root.performance.now(); };
    var wallNow = options.wallNow || function () { return root.Date.now(); };
    var wait = options.wait || function (ms) { return new Promise(function (resolve) { root.setTimeout(resolve, ms); }); };
    var requestTimeoutMs = options.timeoutMs || 15000;
    var expirySafetyMs = 2000;
    var lastTime = null, clockBlocked = false;
    var challenge = null, preparing = null, inFlight = null, inFlightInput = null, attempted = null, accepted = false;
    function timePoint() {
      var point = { monotonic: now(), wall: wallNow() };
      if (clockBlocked || !Number.isFinite(point.monotonic) || !Number.isFinite(point.wall) ||
          (lastTime && (point.monotonic < lastTime.monotonic || point.wall < lastTime.wall))) {
        clockBlocked = true;
        throw fault('clock_changed');
      }
      lastTime = point;
      return point;
    }
    function assertLifetime(reserveMs) {
      var point = timePoint();
      var age = Math.max(point.monotonic - challenge.startedAt.monotonic, point.wall - challenge.startedAt.wall);
      if (age + expirySafetyMs + reserveMs >= binding.nonceMaxAgeSeconds * 1000) {
        throw fault(attempted ? 'retry_expired' : 'challenge_expired');
      }
    }
    function assertBinding() {
      var current;
      try { current = validateBinding(readBinding()); } catch (_) { throw fault('binding_changed'); }
      if (JSON.stringify(current) !== fingerprint) throw fault('binding_changed');
    }
    async function request(path, init) {
      var controller = new root.AbortController();
      var timeout = root.setTimeout(function () { controller.abort(); }, requestTimeoutMs);
      try {
        var response = await fetchRequest(path, Object.assign({ credentials: 'omit', mode: 'cors', cache: 'no-store',
          redirect: 'error', referrerPolicy: 'no-referrer', signal: controller.signal }, init));
        if (response.status !== 200 && response.status !== 202) return { status: response.status };
        var body;
        try { body = await response.json(); } catch (_) { throw fault('protocol'); }
        return { status: response.status, body: body };
      } catch (error) { throw fault(error.code === 'protocol' ? 'protocol' : 'network'); }
      finally { root.clearTimeout(timeout); }
    }
    function prepare() {
      if (challenge) return Promise.resolve();
      if (preparing) return preparing;
      preparing = (async function () {
        assertBinding();
        var startedAt = timePoint();
        var response = await request(binding.endpoint + '/challenge', { method: 'GET', headers: { Accept: 'application/json' } });
        if (response.status !== 200) throw fault('network');
        var body = response.body;
        if (!body || typeof body.nonce !== 'string' || !/^f[12]\.[A-Za-z0-9_-]{1,256}\.[A-Za-z0-9_-]{43}$/.test(body.nonce) ||
            !Number.isInteger(body.minSubmitSeconds) || body.minSubmitSeconds < 0 || body.minSubmitSeconds > 300) throw fault('protocol');
        assertBinding();
        challenge = { nonce: body.nonce, startedAt: startedAt, readyAt: timePoint().monotonic + body.minSubmitSeconds * 1000 + 250 };
        assertLifetime(body.minSubmitSeconds * 1000 + 250 + requestTimeoutMs);
      })().finally(function () { preparing = null; });
      return preparing;
    }
    function submit(emailValue, locale, honeypot, extras) {
      var email, normalizedLocale = localeOf(locale);
      try {
        assertBinding();
        email = normalizeEmail(emailValue);
        if (attempted && (attempted.email !== email || attempted.locale !== normalizedLocale || attempted.honeypot !== (honeypot || ''))) throw fault('retry_locked');
        if (inFlightInput && (inFlightInput.email !== email || inFlightInput.locale !== normalizedLocale || inFlightInput.honeypot !== (honeypot || ''))) throw fault('retry_locked');
      } catch (error) { return Promise.reject(error); }
      if (accepted) return Promise.resolve({ accepted: true });
      if (inFlight) return inFlight;
      inFlightInput = { email: email, locale: normalizedLocale, honeypot: honeypot || '' };
      inFlight = (async function () {
        if (!attempted) {
          // No POST was attempted: discard any preloaded challenge before sending.
          if (preparing) await preparing;
          challenge = null;
        }
        await prepare();
        assertLifetime(requestTimeoutMs);
        var remaining = challenge.readyAt - now();
        while (remaining > 0) {
          await wait(Math.ceil(remaining));
          var nextRemaining = challenge.readyAt - now();
          if (nextRemaining >= remaining) throw fault('protocol');
          remaining = nextRemaining;
        }
        assertBinding();
        assertLifetime(requestTimeoutMs);
        var payload = { nonce: challenge.nonce, email: email, consentTextVersion: binding.consentTextVersion };
        if (binding.localeField) payload.locale = normalizedLocale;
        if (binding.honeypotField) payload[binding.honeypotField] = honeypot || '';
        binding.fields.forEach(function (f) {
          if (ATTRIBUTION_FIELDS.indexOf(f) >= 0) return;
          var v = extras && extras[f];
          if (typeof v === 'string' && v && v.length <= 500) payload[f] = v;
        });
        var denied = extras && (extras.ads_optout === true || extras.ads_optout === '1' || extras.ads_optout === 'true');
        if (denied) payload.ads_optout = '1';
        else {
          // Supplemental attribution is independent of the published contact fields.
          var attributionParams = new URLSearchParams();
          ATTRIBUTION_FIELDS.forEach(function (name) {
            if (extras && typeof extras[name] === 'string') attributionParams.set(name, extras[name]);
          });
          var attribution = readAttribution(attributionParams);
          Object.keys(attribution).forEach(function (name) { payload[name] = attribution[name]; });
        }
        attempted = { email: email, locale: normalizedLocale, honeypot: honeypot || '' };
        var response = await request(binding.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
        assertBinding();
        assertLifetime(0);
        if (response.status !== 202) throw fault('network');
        var body = response.body;
        if (!body || body.ok !== true) throw fault('protocol');
        assertBinding();
        accepted = true;
        return { accepted: true };
      })().finally(function () { inFlight = null; inFlightInput = null; });
      return inFlight;
    }
    return Object.freeze({ prepare: prepare, submit: submit });
  }
  var shared = null;
  function mountedSession(readBinding) {
    var fingerprint = JSON.stringify(validateBinding(readBinding()));
    if (shared) {
      if (shared.fingerprint !== fingerprint) throw fault('binding_changed');
      shared.readers.push(readBinding);
      return shared.session;
    }
    shared = { fingerprint: fingerprint, readers: [readBinding], session: null };
    shared.session = createSession(function () {
      var current;
      shared.readers.forEach(function (read) {
        current = read();
        if (JSON.stringify(validateBinding(current)) !== shared.fingerprint) throw fault('binding_changed');
      });
      return current;
    });
    return shared.session;
  }
  function mount(form, handlers) {
    if (!form || form._sfHubMounted) return;
    form._sfHubMounted = true;
    handlers = handlers || {};
    var container = form.closest('[data-sf-hub-root]');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var errorElement = handlers.errorElement || container.querySelector('[data-sf-hub-error]');
    var resultElement = container.querySelector('[data-sf-hub-result]');
    var locale = localeOf(root.document.documentElement.lang);
    var busy = false, complete = false, blocked = false, session, extras = null;
    function showError(code) {
      if (errorElement) { errorElement.textContent = message(code, locale); errorElement.hidden = false; errorElement.classList.add('is-visible'); }
    }
    function readBinding() {
      var node = container.querySelector('script[data-sf-hub-binding]');
      try { return JSON.parse(node.textContent); } catch (_) { throw fault('unavailable'); }
    }
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!session || busy || complete) return;
      if (handlers.validate) {
        var invalid = handlers.validate();
        if (invalid) {
          if (errorElement) { errorElement.textContent = invalid; errorElement.hidden = false; errorElement.classList.add('is-visible'); }
          return;
        }
      }
      busy = true; button.disabled = true; input.disabled = true;
      if (errorElement) { errorElement.textContent = ''; errorElement.classList.remove('is-visible'); }
      if (handlers.onBusy) handlers.onBusy(true);
      try {
        var honeypot = form.querySelector('[data-sf-hub-honeypot]');
        try { extras = handlers.extras ? handlers.extras() || {} : {}; } catch (_) { extras = {}; }
        await session.submit(input.value, locale, honeypot ? honeypot.value : '', extras);
        complete = true;
        root.document.dispatchEvent(new CustomEvent('sf:bf-request-accepted'));
        if (resultElement) { resultElement.hidden = false; resultElement.textContent = message('accepted', locale); }
        if (handlers.onAccepted) handlers.onAccepted(input.value, extras);
      } catch (error) { blocked = ['binding_changed', 'challenge_expired', 'retry_expired', 'clock_changed'].includes(error.code); showError(error.code); }
      finally {
        busy = false; button.disabled = complete || blocked; input.disabled = complete || blocked;
        if (handlers.onBusy) handlers.onBusy(false);
      }
    });
    try {
      if (form.dataset.sfHubPreview === 'true') throw fault('preview');
      var binding = validateBinding(readBinding());
      session = mountedSession(readBinding);
      if (binding.honeypotField) {
        var trap = root.document.createElement('input');
        trap.type = 'text'; trap.name = binding.honeypotField; trap.autocomplete = 'off'; trap.tabIndex = -1;
        trap.dataset.sfHubHoneypot = ''; trap.setAttribute('aria-hidden', 'true');
        trap.style.cssText = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden';
        form.appendChild(trap);
      }
      input.disabled = false; button.disabled = false;
      if (errorElement) { errorElement.textContent = ''; errorElement.hidden = true; errorElement.classList.remove('is-visible'); }
    } catch (error) {
      input.disabled = true; button.disabled = true; showError(error.code);
    }
  }
  root.BbBfHub = Object.freeze({ validateBinding: validateBinding, createSession: createSession, mount: mount, message: message });
  if (root.document) {
    root.document.dispatchEvent(new root.CustomEvent('sf:bf-hub-ready'));
  }
})(typeof window === 'undefined' ? globalThis : window);
